<template>
	<div style="color: #000;font-weight: 900;">
		<div style="padding: 20px;border-bottom: 1px solid #ccc;font-size: 28px;background-color: #fff;">
			<span>确认和调整报告内容</span>
		</div>

		<div>
			<div class="panel">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						基础信息
					</div>
					<div>
						<a class="btn btn-success" @click="save(0)">保存修改</a>
					</div>
				</div>
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
						<div class="row cl">
							<label for="_姓名" class="form-label col-xs-4 col-sm-2">姓名</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.name" id="_姓名" type="text" name="姓名" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_性别" class="form-label col-xs-4 col-sm-2">性别</label>
							<div class="formControls col-xs-8 col-sm-9">
								<select v-model="main.Gender" id="_性别" name="性别" required class="input-text save_tag">
									<option value="男">男</option>
									<option value="女">女</option>
								</select>
							</div>
						</div>
						<div class="row cl">
							<label for="_年龄" class="form-label col-xs-4 col-sm-2">年龄</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.Age" id="_年龄" type="text" name="年龄" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_联系方式" class="form-label col-xs-4 col-sm-2">联系方式</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.Contactinformation" id="_联系方式" type="text" name="联系方式" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">fitter</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.fitter" id="_fitter" type="text" name="fitter" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">骑行中的不适或疼痛</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.tt" type="text" name="tt" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">历史伤病</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.sb" type="text" name="sb" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">本次Bike Fitting目的</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.md" type="text" name="md" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">近期目标活动或赛事</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.ss" type="text" name="ss" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">其他信息</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="main.qt" type="text" name="qt" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div>
			<div class="panel">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						测量信息
					</div>
					<div>
						<a class="btn btn-success" @click="save(5)">保存修改</a>
					</div>
				</div>
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
						<block v-for="(item, index) in cl" :key="index">
							
						
						<div class="row cl" v-for="(items, indexs) in item" :key="indexs">
							<label :for="item.title+'('+items.userhelp+items.suffix+')'" class="form-label col-xs-4 col-sm-2">{{items.title}}</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="items.value" :id="items.title" type="text" :name="items.title" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>
						</block>
					</form>
				</div>
			</div>
		</div>
		<div>
			<div class="panel">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						运动功能筛查
					</div>
					<div>
						<a class="btn btn-success" @click="save(1)">保存修改</a>
					</div>
				</div>
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">

						<div v-for="(item, index) in sc" :key="index">
							<div class="row cl">
								<label class="form-label col-xs-4 col-sm-2">{{item[0]}}</label>
								<div class="formControls col-xs-8 col-sm-9">
									<input v-model="item[1]" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
							</div>
							<div class="row cl">
								<label class="form-label col-xs-4 col-sm-2">备注</label>
								<div class="formControls col-xs-8 col-sm-9">
									<input v-model="item[2]" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
							</div>
							<div style="padding: 20px 60px;padding-right: 120px;">
								<div style="border-bottom: 1px dashed #fff ;">

								</div>
							</div>
						</div>


						<div class="row cl">
							<label for="_fitter" class="form-label col-xs-4 col-sm-2">备注</label>
							<div class="formControls col-xs-8 col-sm-9">
								<input v-model="sc_bz" type="text" required autocomplete="off" class="input-text save_tag">
							</div>
						</div>


					</form>
				</div>
			</div>
		</div>
<div>

			<div class="panel" style="background-color:#fff;">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						分析数据对比
					</div>
					<div>
						<a class="btn btn-success" @click="save(6)">保存修改</a>
					</div>
				</div>
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
						<div v-for="(item, index) in dba" :key="index">

							<div class="row cl">
								<label class="form-label col-xs-4 col-sm-2">{{dba[index].name}}</label>
								<div class="formControls col-xs-4 col-sm-4">
									<input style="width: 300px;" placeholder="Fitting前" v-model="dba[index].val" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
								<div class="formControls col-xs-4 col-sm-4">
									<input style="width: 300px;" placeholder="Fitting后" v-model="dbb[index].val" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div>

			<div class="panel" style="background-color:#fff;">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						调车数据
					</div>
					<div>
						<a class="btn btn-success" @click="save(3)">保存修改</a>
					</div>
				</div>
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
						<div v-for="(item, index) in set_bf" :key="index">

							<div class="row cl">
								<label class="form-label col-xs-4 col-sm-2">{{item[0]}}</label>
								<div class="formControls col-xs-4 col-sm-4">
									<input style="width: 300px;" :placeholder="item[0]" v-model="item[1]" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
								<div class="formControls col-xs-4 col-sm-4">
									<input style="width: 300px;" :placeholder="item[0]" v-model="item[2]" type="text" required autocomplete="off" class="input-text save_tag">
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div>

			<div class="panel" style="background-color:#fff;">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						案例总结
					</div>
				</div>
				<div class="panel-body">
					<form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
						<div class="row cl">
							<label class="form-label col-xs-4 col-sm-2">案例总结</label>
							<div class="formControls col-xs-8 col-sm-9">
								<textarea v-model="finish_zj" style="width: 600px; height: 800px; background-color: #fff; border: 1px solid #ccc; color: #000; font-size: 16px;" placeholder="案例总结."></textarea>
							</div>
						</div>
						<div class="row cl">
							<div class="col-xs-8 col-sm-9 col-xs-offset-4 col-sm-offset-3">
								<input class="btn btn-primary radius ml-10" type="button" @click="save(4)" value="提交并生成报告">
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'fcl', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				dba:[],
				dbb:[],
				
				// 在这里定义你的组件数据
				sta: 0,
				set_bf: [
					["坐垫高度[毫米]", "", ""],
					["有效坐垫后移量[毫米]", "", ""],
					["手变Reach[毫米]", "", ""],
					["手变Stack[毫米]", "", ""],
					["把立长度[毫米]", "", ""],
					["把立角度[度数]", "", ""],
					["垫圈[简要描述]", "", ""],
					["弯把Reach[毫米]", "", ""],
					["上把位宽度[毫米]", "", ""],
					["坐垫信息[简要描述]", "", ""],
					["坐垫角度[度数]", "", ""],
					["曲柄长度[毫米]", "", ""],
					["座管信息[简要描述]", "", ""],
					["锁鞋信息[简要描述]", "", ""],
					["锁片旋转[度数]", "", ""],
					["锁鞋垫片[简要描述]", "", ""],
					["鞋垫[简要描述]", "", ""],
					["脚踏[简要描述]", "", ""]
				],
				img_h: 'https://bikecdn.typhcl.cn/tool/cls/',
				f_h: 'https://bikecdn.typhcl.cn/tool/cls/',
				src: "",
				list: [],
				sc: [
					["长短腿", "正常", "双腿长度无明显差异"],
					["左-腘绳肌 [直膝抬腿]", "70-90度", "左腿腘绳肌灵活度正常，请加强腘绳肌群拉伸锻炼"],
					["右-腘绳肌 [直膝抬腿]", "70-90度", "右腿腘绳肌灵活度正常，请加强腘绳肌群拉伸锻炼"],
					["左-臀肌群 [屈膝屈髋]", "大于120度", "左-臀肌群指标正常，保持臀肌群力量及拉伸锻炼"],
					["右-臀肌群 [屈膝屈髋]", "大于120度", "右-臀肌群指标正常，保持臀肌群力量及拉伸锻炼"],
					["左-髋关节灵活度", "内转紧张", "左腿髋关节灵活度内旋紧张，屈髋时容易受限，需要加强髋关节放松拉伸"],
					["右-髋关节灵活度", "内转紧张", "右腿髋关节灵活度内旋紧张，屈髋时容易受限，需要加强髋关节放松拉伸"],
					["左-足内外翻", "正常", "左脚掌无明显内外翻，脚底受力均衡"],
					["右-足内外翻", "正常", "右脚掌无明显内外翻，脚底受力均衡"],
					["足弓形态", "正常足弓", "足弓正常，若鞋底支撑不足，膝盖轨迹不够稳定，膝盖易疼痛，可使用中足弓鞋垫支撑"],
					["内外八", "正常", "步态正常，无内外八字脚"],
					["上肢稳定 [俯卧撑]", "普通", "上肢力量普通，需提高胸大肌、肱三头肌等锻炼"],
					["核心稳定 [平板支撑]", "弱", "核心力量较弱，需提高核心部位的大小肌群，包括腹横肌、腹直肌、腹斜肌等锻炼"],
					["左腿部稳定 [单腿半蹲]", "普通", "加强臀大肌、臀中肌、比目鱼肌锻炼，排查髋关节或骨盆扭转障碍及胫骨扭转功能异常"],
					["右腿部稳定 [单腿半蹲]", "普通", "加强臀大肌、臀中肌、比目鱼肌锻炼，排查髋关节或骨盆扭转障碍及胫骨扭转功能异常"],
					["下肢柔韧 [立位体前屈]", "到脚踝", "下肢柔韧性一般，请加强大腿、小腿后侧肌群的拉伸"],
					["肩部柔韧 [合十上推]", "低于下巴", "肩部柔韧性差，需要拉伸三角肌，菱形肌，斜方肌"],
					["肩峰宽度[测量]", "37cm", "根据肩峰宽度及骑行风格，选择合适宽度的车把"],
					["坐骨宽度[测量]", "≈110mm", "根据坐骨宽度，确定坐垫的有效支撑范围，判断坐垫是否适合骑手"]
				],
				main: {
					name: ""
				},
				dat: [],
				sc_bz: "",
				finish_zj: "",
				cl_bz: "",
				cl:[],
				lists: [{
						"title": "请测量身高：赤脚站立，双脚张开8CM，测量头顶到地面的距离。",
						"mp3": "01.MP3",
						"img": "1.png",
						"index": 0,
						"indexs": 0
					},
					{
						"title": "请测量跨高：穿着骑行裤，赤脚站立，双脚张开8CM，水平尺保持水平，用力提拉，测量水平尺上沿到地面的高度。",
						"mp3": "02.MP3",
						"img": "2.png",
						"index": 0,
						"indexs": 1
					}, {
						"title": "请测量胸骨高度：赤脚站立，双脚张开8CM，测量锁骨凹到地面的距离。",
						"mp3": "03.MP3",
						"img": "3.png",
						"index": 0,
						"indexs": 2
					}, {
						"title": "请测量臂长：将手臂伸直，测量肱骨大结节到手掌中心长度，可以手握一个圆柱体来辅助测量",
						"mp3": "04.MP3",
						"img": "4.png",
						"index": 0,
						"indexs": 3
					}, {
						"title": "请测量肩宽：肩膀放松，测量左右肩峰的距离",
						"mp3": "05.MP3",
						"img": "5.png",
						"index": 0,
						"indexs": 4
					}, {
						"title": "请测量大腿长：平坐保持大腿与地面平行，测量从臀部到膝盖髌骨长度。",
						"mp3": "06.MP3",
						"img": "6.png",
						"index": 0,
						"indexs": 5
					}, {
						"title": "柔韧性评估，尝试做几次立位体前屈，记录自己指尖到地面的最低距离，30厘米以内，20厘米以内，10厘米以内，或完全手掌碰地。",
						"mp3": "07.MP3",
						"img": "7.png",
						"index": 1,
						"indexs": 0
					}, {
						"title": "核心力量评估，计时并开始平板支撑，记录自己的持续最大时间，30秒以内,60秒以内，90秒以内，120秒以内，或120秒以上。",
						"mp3": "08.MP3",
						"img": "8.png",
						"index": 1,
						"indexs": 1
					}, {
						"title": "请设置车辆立管角度，如图测量立管和水平地面的倾斜角度即可，可以查询自己的车架信息或手动测量,大多数车辆均为73度。",
						"mp3": "09.MP3",
						"img": "9.png",
						"index": 2,
						"indexs": 0
					},
					{
						"title": "日常骑行过程中，是否有膝盖疼痛问题，如果存在请选择具体部位,没有请跳过",
						"mp3": "10.MP3",
						"img": "10.png",
						"index": 3,
						"indexs": 0,
						"opt": [{
								"name": "膝盖前端疼痛",
								"sel": false
							},
							{
								"name": "膝盖内侧疼痛",
								"sel": false
							},
							{
								"name": "膝盖外侧疼痛",
								"sel": false
							},
							{
								"name": "膝盖后面疼痛",
								"sel": false
							}
						]
					},
					{
						"title": "日常骑行过程中，是否有腿部疼痛问题，如果存在请选择具体部位，没有请跳过",
						"mp3": "11.MP3",
						"img": "11.png",
						"index": 3,
						"indexs": 1,
						"opt": [{
								"name": "脚掌痛或麻木",
								"sel": false
							},
							{
								"name": "脚抽筋",
								"sel": false
							},
							{
								"name": "跟腱疼痛",
								"sel": false
							}
						]
					},
					{
						"title": "日常骑行过程中，是否有髋部疼痛问题，如果存在请选择，没有请跳过",
						"mp3": "12.MP3",
						"img": "12.png",
						"index": 3,
						"indexs": 2,
						"opt": [{
							"name": "髋部疼痛",
							"sel": false
						}]
					},
					{
						"title": "日常骑行过程中，是否有腰部疼痛问题，如果存在请选择，没有请跳过",
						"mp3": "13.MP3",
						"img": "13.png",
						"index": 3,
						"indexs": 3,
						"opt": [{
							"name": "腰部疼痛",
							"sel": false
						}]
					},
					{
						"title": "日常骑行过程中，是否有上肢疼痛或其他问题，如果存在请选择，没有请跳过",
						"mp3": "14.MP3",
						"img": "14.png",
						"index": 3,
						"indexs": 4,
						"opt": [{
								"name": "肩膀、手肘过度疲劳或疼痛",
								"sel": false
							},
							{
								"name": "前臂、手掌疼痛",
								"sel": false
							}
						]
					},
					{
						"title": "日常骑行过程中，是否有脖子疼痛问题，如果存在请选择，没有请跳过",
						"mp3": "15.MP3",
						"img": "15.png",
						"index": 3,
						"indexs": 5,
						"opt": [{
							"name": "脖子疼痛",
							"sel": false
						}]
					},
					{
						"title": "如果有其他身体不适或长短腿等情况，请备注。",
						"mp3": "16.MP3",
						"img": "16.png",
						"index": 4,
						"indexs": 0,
						"opt": []
					}

				]
			};
		},
		computed: {
			// 计算属性
		},
		methods: {
			// 方法
			c_slider(e, val) {
				var that = this
				console.log(e, val)
				//	that.dat[0][e.currentTarget.id].value = e.detail.value;
			},
			cbChange(index, indexs) {
				var that = this
				//that.lists[index].opt[indexs].sel = !that.lists[index].opt[indexs].sel
				console.log(that.lists[index].opt[indexs].sel)
			},
			radioChange(e) {
				var that = this
				console.log(e);
				var dat = e;
				var dats = dat.split("_");
				that.dat[1][dats[0]].value = that.dat[1][dats[0]].choicesVal[dats[1]];
				that.dat[1][dats[0]].curr = dats[1];

				console.log(e)
			},
			change_step(e) {
				var that = this

				that.dat[that.curr][e[0]].value = e[1];
			},
			get_dat(name) {
				var that = this
				for (var i in that.$data.dat) {
					for (var j in that.$data.dat[i]) {
						if (that.$data.dat[i][j].name == name) {

							if (typeof(that.$data.dat[i][j].value) != 'undefined' && that.$data.dat[i][j].value != "") {

								return parseFloat(that.$data.dat[i][j].value);
							}

						}
					}
				}
				console.log(name, this.fix_function(name))
				return this.fix_function(name);
			},
			fix_function(name) {
				var that = this

				switch (name) {
					case "fieldname13":
						if ((parseInt(that.get_dat('fieldname11')) + parseInt(that.get_dat('fieldname12'))) < 5) return "休闲";
						if ((parseInt(that.get_dat('fieldname11')) + parseInt(that.get_dat('fieldname12'))) < 8) return "普通";
						if ((parseInt(that.get_dat('fieldname11')) + parseInt(that.get_dat('fieldname12'))) < 11) return "激进";

						break;
					case "fieldname14":
						console.log("fieldname14", that.get_dat('fieldname11') + that.get_dat('fieldname12'), that.get_dat('fieldname10'))
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 150)) return -20;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 151)) return -18;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 152)) return -16;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 153)) return -14;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 154)) return -12;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 155)) return -10;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 156)) return -8;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 157)) return -6;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 158)) return -4;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 159)) return -2;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 160)) return -10;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 161)) return -8;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 162)) return -6;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 163)) return -4;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 164)) return -2;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 165)) return 0;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 166)) return 2;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 167)) return 4;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 168)) return 6;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 169)) return 8;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 170)) return 0;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 171)) return 2;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 172)) return 4;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 173)) return 6;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 174)) return 8;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 175)) return 10;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 176)) return 12;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 177)) return 14;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 178)) return 16;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 179)) return 18;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 180)) return 10;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 181)) return 12;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 182)) return 14;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 183)) return 16;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 184)) return 18;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 185)) return 20;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 186)) return 22;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 187)) return 24;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 188)) return 26;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 189)) return 28;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 190)) return 20;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 191)) return 22;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 192)) return 24;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 193)) return 26;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 194)) return 28;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 195)) return 30;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 196)) return 32;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 197)) return 34;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 198)) return 36;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 199)) return 38;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 5) && (that.get_dat('fieldname10') == 200)) return 40;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 150)) return 0;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 151)) return 1;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 152)) return 2;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 153)) return 3;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 154)) return 4;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 155)) return 5;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 156)) return 6;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 157)) return 7;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 158)) return 8;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 159)) return 9;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 160)) return 10;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 161)) return 12;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 162)) return 14;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 163)) return 16;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 164)) return 18;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 165)) return 20;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 166)) return 22;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 167)) return 24;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 168)) return 26;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 169)) return 28;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 170)) return 20;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 171)) return 23;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 172)) return 26;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 173)) return 29;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 174)) return 32;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 175)) return 35;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 176)) return 38;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 177)) return 41;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 178)) return 44;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 179)) return 47;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 180)) return 30;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 181)) return 34;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 182)) return 38;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 183)) return 42;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 184)) return 46;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 185)) return 50;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 186)) return 54;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 187)) return 58;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 188)) return 62;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 189)) return 66;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 190)) return 40;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 191)) return 44;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 192)) return 48;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 193)) return 52;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 194)) return 56;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 195)) return 60;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 196)) return 64;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 197)) return 68;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 198)) return 72;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 199)) return 76;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 8) && (that.get_dat('fieldname10') == 200)) return 80;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 150)) return 10;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 151)) return 14;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 152)) return 18;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 153)) return 22;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 154)) return 26;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 155)) return 30;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 156)) return 34;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 157)) return 38;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 158)) return 42;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 159)) return 46;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 160)) return 30;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 161)) return 33;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 162)) return 36;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 163)) return 39;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 164)) return 42;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 165)) return 45;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 166)) return 48;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 167)) return 51;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 168)) return 54;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 169)) return 57;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 170)) return 50;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 171)) return 54;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 172)) return 58;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 173)) return 62;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 174)) return 66;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 175)) return 70;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 176)) return 74;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 177)) return 78;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 178)) return 82;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 179)) return 86;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 180)) return 60;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 181)) return 65;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 182)) return 70;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 183)) return 75;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 184)) return 80;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 185)) return 85;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 186)) return 90;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 187)) return 95;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 188)) return 100;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 189)) return 105;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 190)) return 80;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 191)) return 85;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 192)) return 90;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 193)) return 95;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 194)) return 100;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 195)) return 105;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 196)) return 110;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 197)) return 115;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 198)) return 120;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 199)) return 125;
						if ((that.get_dat('fieldname11') + that.get_dat('fieldname12') < 11) && (that.get_dat('fieldname10') == 200)) return 130;

						break;
					case "fieldname15":
						return that.floats(that.get_dat('fieldname1') * 0.883 * 10, 0)
						break;
					case "fieldname17":
						return (90 - that.get_dat('fieldname16')) / 57.3
						break;
					case "fieldname18":
						return that.floats(that.get_dat('fieldname15') * Math.cos(that.get_dat('fieldname17')) - that.get_dat('fieldname14') - 40, 0)
						break
					case "fieldname19":
						return that.floats((((that.get_dat("fieldname5") - that.get_dat("fieldname1")) * 10 + that.get_dat("fieldname4") * 10) * that.get_dat("fieldname20") - that.get_dat("fieldname15") * Math.sin(that.get_dat("fieldname17")) + 90), 0);
						break;
					case "fieldname20":
						console.log("fieldname20", that.get_dat('fieldname11') + that.get_dat('fieldname12'), that.get_dat('fieldname10'))

						if (this.get_dat('fieldname11') + this.get_dat('fieldname12') < 5)
							return 0.52;
						if (this.get_dat('fieldname11') + this.get_dat('fieldname12') < 8)
							return 0.535;
						if (this.get_dat('fieldname11') + this.get_dat('fieldname12') < 11)
							return 0.545;
						break;
					case "fieldname21":
						return that.floats(that.get_dat('fieldname6') * 1.2 + 130, 0);
						break;
					case "fieldname22":
						if (that.get_dat('fieldname3') <= 38) return 38;
						if (that.get_dat('fieldname3') < 41) return 40;
						if (that.get_dat('fieldname3') < 43) return 42;
						if (that.get_dat('fieldname3') < 46) return 44;
						if (that.get_dat('fieldname3') >= 46) return 46;
						break;
					case "fieldname23":
						if (that.get_dat('fieldname1') <= 71) return 165;
						if (that.get_dat('fieldname1') <= 83) return 170;
						if (that.get_dat('fieldname1') <= 89) return 172.5;
						if (that.get_dat('fieldname1') > 89) return 175;
						break;
					case "fieldname32":
						return that.floats(that.get_dat('fieldname19') - that.get_dat('fieldname28') - that.get_dat('fieldname51') - that.get_dat('fieldname25') * Math.cos((that.get_dat('fieldname26') + 90 - that.get_dat('fieldname24')) * 3.14159 / 180) + Math.sin((90 - that.get_dat('fieldname24')) * 3.14159 / 180) * (that.get_dat('fieldname27') + that
							.get_dat(
								'fieldname29') / 2), 0)
						break;
					case "fieldname35":
						return that.floats(that.get_dat('fieldname18') - that.get_dat('fieldname31') - that.get_dat('fieldname25') * Math.sin((that.get_dat('fieldname26') + 90 - that.get_dat('fieldname24')) * 3.14159 / 180) - (that.get_dat('fieldname29') / 2 + that.get_dat('fieldname50') / 2 + that.get_dat('fieldname27')) * Math.cos((90 - that.get_dat(
							'fieldname24')) * 3.14159 / 180), 0)
						break;
					default:
						console.error(name, "不存在");
						break;
				}
			}

			,
			floats(dat, f) {
				return dat.toFixed(f);
			},
			save(sta) {
				var that = this
				switch (sta) {
					case 0:
						$.ajax({
							url: that.URL,
							data: {
								t: "save_xx",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								main: JSON.stringify(that.$data.main)
							},
							dataType: "json",
							success(e) {
								alert("已保存");
							}
						})
						break;
					case 1:
						$.ajax({
							url: that.URL,
							data: {
								t: "save_sc",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								main: JSON.stringify(that.$data.sc),
								bz: that.$data.sc_bz
							},
							dataType: "json",
							success(e) {
								alert("已保存");
							}
						})

						break;
					case 3:
						$.ajax({
							url: that.URL,
							data: {
								t: "save_bf_cl",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								dat: JSON.stringify(that.$data.set_bf),
							},
							dataType: "json",
							success(e) {
								alert("已保存");
							}
						})
						break;
					case 4:
						var that = this
						$.ajax({
							url: that.URL,
							data: {
								t: "save_send_bg",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								dat: JSON.stringify(that.$data.set_bf),
								bz: that.$data.finish_zj
							},
							dataType: "json",
							success(e) {
								location.href = "https://bike.typhcl.cn/md/rep.php?id=" + that.$data.id;
							}
						})
						break;
						case 5:
							var that = this
							$.ajax({
								url: that.URL,
								data: {
									t: "save_bf_cls",
									token: localStorage.getItem('token'),
									id: that.$data.id,
									dat: JSON.stringify(that.$data.cl),
								},
								dataType: "json",
								success(e) {
									alert("已保存");
								}
							})
							break;
							case 6:
								var that = this
								$.ajax({
									url: that.URL,
									data: {
										t: "save_db",//角度对比
										token: localStorage.getItem('token'),
										id: that.$data.id,
										data: JSON.stringify(that.$data.dba),
										datb: JSON.stringify(that.$data.dbb),
									},
									dataType: "json",
									success(e) {
										alert("已保存");
									}
								})
								break;
				}
			},
			next() {
				var that = this
				switch (that.$data.sta) {
					case 0:
						$.ajax({
							url: that.URL,
							data: {
								t: "save_xx",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								main: JSON.stringify(that.$data.main)
							},
							dataType: "json",
							success(e) {
								that.$data.sta++;
							}
						})

						break;
					case 1:
						$.ajax({
							url: that.URL,
							data: {
								t: "save_sc",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								main: JSON.stringify(that.$data.sc),
								bz: that.$data.sc_bz
							},
							dataType: "json",
							success(e) {
								that.$data.sta++;
							}
						})

						break;
					case 2:
						var tt = "";
						for (var i in that.$data.lists) {
							if (that.$data.lists[i].index == 3) {
								for (var j in that.$data.lists[i].opt) {
									if (that.$data.lists[i].opt[j].sel) {
										tt += that.$data.lists[i].opt[j].name + "[|br|]"
									}
								}
							}
						}

						var list = [];
						//var dat = ["name", "max", "min", "value", "title", "ftype", "suffix", "userhelp", "index"];
						for (var i in that.$data.dat) {
							var tmp = [];
							for (var j in that.$data.dat[i]) {
								tmp.push({
									"name": that.$data.dat[i][j]["name"],
									"max": parseInt(that.$data.dat[i][j]["max"]),
									"min": parseInt(that.$data.dat[i][j]["min"]),
									"value": that.get_dat(that.$data.dat[i][j]["name"]),
									"title": that.$data.dat[i][j]["title"],
									"ftype": that.$data.dat[i][j]["ftype"],
									"suffix": typeof(that.$data.dat[i][j]["suffix"]) == 'undefined' ? '' : that.$data.dat[i][j]["suffix"],
									"userhelp": that.$data.dat[i][j]["userhelp"],
									"index": that.$data.dat[i][j]["index"]
								});
							}
							list[i] = tmp;
						}
						console.log(tt)
						console.log(list);

						$.ajax({
							url: that.URL,
							data: {
								t: "save_cl",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								list: JSON.stringify(list),
								lists: JSON.stringify(that.$data.lists),
								tt: tt,
								bz: that.$data.cl_bz
							},
							dataType: "json",
							success(e) {
								that.$data.sta++;
							}
						})

						break;
					case 3:
						$.ajax({
							url: that.URL,
							data: {
								t: "save_bf_cl",
								token: localStorage.getItem('token'),
								id: that.$data.id,
								dat: JSON.stringify(that.$data.set_bf),
							},
							dataType: "json",
							success(e) {
								that.jref_r('./fitting?id=' + that.$data.id);
							}
						})
						break;
				}
			},
			start_fitting() {
				$.ajax({
					url: that.URL,
					data: {
						t: "start_f",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.$router.replace('/fcl?id=' + e.fid);
					}
				})
			},
			init() {
				var that = this
				$.ajax({
					url: "./sta/fitting.json",
					data: {

					},
					dataType: "json",
					success(e) {
						that.$data.dat = e;
						console.log(that.$data.dat)
					}
				})

				$.ajax({
					url: that.URL,
					data: {
						t: "edit_init",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.main = e.main;
						that.sc = e.sc;
						that.set_bf = e.set_bf;
						that.finish_zj = e.finish_zj;
						that.cl=e.cl;
						that.dba=e.dba;
						that.dbb=e.dbb;
					}
				})
			}
		},
		mounted() {
			var that = this
			that.$data.id = this.$route.query.id;
			// 组件挂载后执行的代码

		},
		created() {
			var that = this
			that.$data.id = this.$route.query.id;
			// 组件挂载后执行的代码
			that.init()
		}
	}
</script>

<style>
	.row {
		margin-top: 20px;
	}

	.form-label {
		text-align: left !important;
		/* /color: #fff; */
		padding-left: 40px;
	}
</style>